<template>
    <a-modal
        title="高级搜索"
        :visible="visible"
        :confirm-loading="submitting"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="860"
    >
        <a-form-model :model="form">
            <a-row :gutter="24">
                <a-col :span="8">
                    <a-form-model-item label="姓名">
                        <a-input v-model="form.name" />
                    </a-form-model-item>

                    <a-form-model-item label="手机号码">
                        <a-input v-model="form.mobile" />
                    </a-form-model-item>

                    <a-form-model-item label="微信号">
                        <a-input v-model="form.wechat_id" />
                    </a-form-model-item>

                    <a-form-model-item label="QQ">
                        <a-input v-model="form.qq" />
                    </a-form-model-item>

                    <a-form-model-item label="身份证号码">
                        <a-input v-model="form.id_no" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="项目">
                        <a-select v-model="form.project_id" style="width:100%" placeholder="忽略">
                            <a-select-option value>无</a-select-option>
                            <a-select-option
                                v-for="(item,index) in basic_data_project"
                                :key="index"
                                :value="item.id"
                            >{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="来源渠道" placeholder="忽略">
                        <a-select v-model="form.source_id" style="width:100%">
                            <a-select-option
                                v-for="(item,index) in basic_data_source"
                                :key="index"
                                :value="item.id"
                            >{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="积分">
                        <a-input-group compact>
                            <a-input-number
                                style=" width: 40%; text-align: center"
                                placeholder="大于"
                                v-model="form.point_gte"
                            />
                            <a-input
                                style=" width: 20%; border-left: 0; pointer-events: none; backgroundColor: #fff"
                                placeholder="~"
                                disabled
                            />
                            <a-input-number
                                style="width: 40%; text-align: center; border-left: 0"
                                placeholder="小于"
                                v-model="form.point_lte"
                            />
                        </a-input-group>
                    </a-form-model-item>

                    <a-form-model-item label="总消费">
                        <a-input-group compact>
                            <a-input-number
                                style=" width: 40%; text-align: center"
                                placeholder="大于"
                                v-model="form.expense_gte"
                            />
                            <a-input
                                style=" width: 20%; border-left: 0; pointer-events: none; backgroundColor: #fff"
                                placeholder="~"
                                disabled
                            />
                            <a-input-number
                                style="width: 40%; text-align: center; border-left: 0"
                                placeholder="小于"
                                v-model="form.expense_lte"
                            />
                        </a-input-group>
                    </a-form-model-item>

                    <a-row :gutter="12">
                        <a-col :span="12">
                            <a-form-model-item label="录入时间早于">
                                <a-date-picker v-model="form.created_gte" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="录入时间晚于">
                                <a-date-picker v-model="form.created_lte" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col :span="8">
                    <a-row :gutter="12">
                        <a-col :span="12">
                            <a-form-model-item label="出生日期早于">
                                <a-date-picker v-model="form.birthdate_gte" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="出生日期晚于">
                                <a-date-picker v-model="form.birthdate_lte" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-form-model-item label="录入者">
                        <a-select v-model="form.user_id" style="width:100%" placeholder="忽略">
                            <a-select-option value>无</a-select-option>
                            <a-select-option
                                v-for="(item,index) in basic_data_user"
                                :key="index"
                                :value="item.id.toString()"
                            >{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>
<script>
// import basic_data from "../../mixins/basic_data";
export default {
    //mixins: [basic_data],
    props: {
        visible: false,
        callback: null
    },
    data() {
        return {
            form: {
                name: undefined,
                source_id: undefined,
                project_id: undefined,
                qq: undefined,
                id_no: undefined,
                wechat_id: undefined,
                phone: undefined
            },
            submitting: false
        };
    },
    mounted() {
        // this.load_basic_source();
        // 
        // 
        // this.load_basic_user();
    },
    watch: {
        visible(v) {
            if (v) {
                let query = this.$route.query;
                Object.keys(this.form).map(v => {
                    if (Object.prototype.hasOwnProperty.call(query, v)) {
                        this.form[v] = query[v];
                    } else {
                        this.form[v] = undefined;
                    }
                });
            }
        }
    },
    methods: {
        on_ok() {
            let query = JSON.parse(JSON.stringify(this.form));

            Object.keys(query).map(v => {
                if (query[v] == null || query[v] == "") {
                    delete query[v];
                }
            });

            this.$router.push(`/customer?${this.objectToQuery(query)}`);

            this.on_cancel();
        },
        on_cancel() {
            this.$emit("close");
        }
    }
};
</script>
